import { render, staticRenderFns } from "./vue-slide-verify.vue?vue&type=template&id=12becebd&scoped=true"
import script from "./vue-slide-verify.vue?vue&type=script&lang=js"
export * from "./vue-slide-verify.vue?vue&type=script&lang=js"
import style0 from "./vue-slide-verify.vue?vue&type=style&index=0&id=12becebd&prod&scoped=true&media=screen&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12becebd",
  null
  
)

export default component.exports